// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Yt0S","title":"Header_title__1EndF","left":"Header_left__13YBC","clinicName":"Header_clinicName__1cSPn"};